import { render } from "./TagObject.vue?vue&type=template&id=0a544089&scoped=true"
import script from "./TagObject.vue?vue&type=script&lang=js"
export * from "./TagObject.vue?vue&type=script&lang=js"

import "./TagObject.vue?vue&type=style&index=0&id=0a544089&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a544089"]])

export default __exports__